"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = __importStar(require("react"));
const accordion_styles_1 = require("./accordion.styles");
const ArrowDown = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/arrow-down'))));
const ArrowUp = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/arrow-up'))));
exports.Accordion = (0, react_1.memo)(({ label, value, children, id, size = 'm', color = 'surface', isExpanded = false, }) => {
    const theme = (0, theme_1.useTheme)();
    const accordionRef = (0, react_1.useRef)(null);
    const [currentAccordion, setCurrentAccordion] = (0, react_1.useState)(0);
    const [bodyHeight, setBodyHeight] = (0, react_1.useState)(isExpanded ? 'auto' : '0px');
    const [isOpened, setIsOpened] = (0, react_1.useState)(isExpanded);
    (0, react_1.useEffect)(() => {
        const resizeObserver = new ResizeObserver(() => {
            if (accordionRef.current) {
                setBodyHeight(isOpened ? `${accordionRef.current.scrollHeight}px` : '0px');
            }
        });
        if (accordionRef.current) {
            resizeObserver.observe(accordionRef.current);
        }
        return () => {
            resizeObserver.disconnect();
        };
    }, [isOpened]);
    const handleClick = () => {
        setCurrentAccordion(id);
        setIsOpened((prevOpen) => !prevOpen);
    };
    return (react_1.default.createElement(accordion_styles_1.AccordionInner, { size: size, color: color, hasLabel: Boolean(label) },
        react_1.default.createElement(accordion_styles_1.AccordionItem, { "data-testid": `accordion-item-${id}` },
            react_1.default.createElement(accordion_styles_1.AccordionHeader, { onClick: handleClick, isOpened: isOpened },
                react_1.default.createElement(accordion_styles_1.AccordionTitle, null,
                    label,
                    value),
                react_1.default.createElement(accordion_styles_1.StyledArrow, null,
                    react_1.default.createElement(react_1.Suspense, { fallback: null }, isOpened ? (react_1.default.createElement(ArrowUp, { color: theme.colors.icon.primary })) : (react_1.default.createElement(ArrowDown, { color: theme.colors.icon.primary }))))),
            react_1.default.createElement(accordion_styles_1.AccordionBody, { isActive: currentAccordion === id, bodyHeight: bodyHeight },
                react_1.default.createElement(accordion_styles_1.AccordionBox, { ref: accordionRef }, children)))));
});
